import React from 'react'

/**
 * Marks a field the form will not submit without.
 *
 * Only used where validation actually rejects an empty value, so the mark stays trustworthy -
 * a field carrying one always blocks saving, and a field without one never does.
 */
export const RequiredMark = () => (
    <span className={'required-mark'} title={'Povinné pole'} aria-hidden={'true'}>*</span>
)
